export interface FloorplanPosition {
    key: string;
    x: number;
    y: number;
}

export const separateDuplicateFloorplanPositions = (
    items: FloorplanPosition[],
    horizontalOffset: number
): { changes: FloorplanPosition[]; unresolvedKeys: string[] } => {
    if (!Number.isFinite(horizontalOffset) || horizontalOffset <= 0) {
        throw new RangeError('Floorplan position offset must be a positive finite number.');
    }

    const occupiedPositions = items.map(({ x, y }) => ({ x, y }));
    const seenPositions = new Set<string>();
    const changes: FloorplanPosition[] = [];
    const unresolvedKeys: string[] = [];

    items.forEach((item) => {
        const positionKey = `${item.x}:${item.y}`;
        if (!seenPositions.has(positionKey)) {
            seenPositions.add(positionKey);
            return;
        }

        const isFree = (x: number) => !occupiedPositions.some((position) =>
            position.y === item.y && Math.abs(position.x - x) < horizontalOffset - 1e-8
        );
        let nextX: number | undefined;
        for (let x = item.x - horizontalOffset; x >= 0; x -= horizontalOffset) {
            if (isFree(x)) {
                nextX = x;
                break;
            }
        }
        if (nextX === undefined) {
            for (let x = item.x + horizontalOffset; x <= 100; x += horizontalOffset) {
                if (isFree(x)) {
                    nextX = x;
                    break;
                }
            }
        }
        if (nextX === undefined) {
            unresolvedKeys.push(item.key);
            return;
        }

        const position = { ...item, x: nextX };
        occupiedPositions.push(position);
        changes.push(position);
    });

    return { changes, unresolvedKeys };
};
